<div *ngIf="binder">
    <form [formGroup]="cardScanInputForm">
        <table style="width:100%;">
            <tr>
                <td style="width:100%;">
                    <mat-form-field appearance="fill" style="width:100%;">
                        <mat-label>Inventory ID</mat-label>
                        <input matInput #inventoryID formControlName="InventoryID" (focus)="input_focus()"
                            (blur)="input_blur()" (keydown.enter)="cardScanInputFormSubmit()" autofocus />
                    </mat-form-field>
                </td>
                <td style="height:100%;">
                    <button mat-raised-button color="primary" style="margin-left:1em; vertical-align: middle;"
                        type="button" (click)="gotoBinderList()">Back</button>
                </td>
            </tr>
        </table>
    </form>

    <table>
        <tr *ngFor="let card of binderCards" class="binder-card">
            <td>
                <button mat-button (click)="toggleAuditCheck(card, $event)" class="audit-checkbox">
                    <mat-icon *ngIf="binders.AuditStatus(card)">checkmark</mat-icon>
                </button>
            </td>
            <td>
                <mat-chip-list>
                    <mat-chip [style.backgroundColor]="LifeCycleColor(card.LifeCycle)"
                        [style.color]="LifeCycleContrastColor(card.LifeCycle)" class="inventory-id-chip">
                        {{card.InventoryID}}
                    </mat-chip>
                </mat-chip-list>
            </td>
            <td style="font-size:smaller;">
                {{card.Description}}
            </td>
        </tr>
    </table>
</div>